module.exports = __webpack_public_path__ + "static/media/icon-twitter.ecca44d9.svg";